module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/bravenet_sitebuilder_social_media_integration.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/sitebuilder/bravenet_sitebuilder_social_media_integration.png
// module id = nKZW
// module chunks = 0